export default __webpack_public_path__ + "static/media/fad-xlrplug.65bc2992.svg";